import React from "react";
import Modal from "react-modal";
import { UserContext } from "../UserContext";
import { auth } from "../firebase-config";

import styles from "./ModalLogOut.module.css";

const ModalLogOut = ({ isOpen, onRequestClose, data, setData }) => {
  const { userLogout } = React.useContext(UserContext);
  function handleCloseModalLogout() {
    userLogout(auth);
    onRequestClose();
    localStorage.clear();
    history.push("/login");
  }
  return (
    <div className="container">
      <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        contentLabel="Selected Option"
        overlayClassName="react-modal-overlay-logout"
        className="react-modal-content-logout"
        onRequestClose={onRequestClose}
      >
        {" "}
        <button
          className="react-modal-close"
          type="button"
          onClick={onRequestClose}
        >
          <span>&#x2715;</span>
        </button>
        <div className={styles.contentModal}>
          <h2>Deseja sair?</h2>
          <div className={styles.contentModalBtn}>
            <button onClick={handleCloseModalLogout}>Sim</button>
            <button onClick={onRequestClose}>Não</button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ModalLogOut;
